import React from 'react';
import './styles.scss';

const TableHeader = ({columns, onSort, sortConfig, sortableColumns = []}) => {
  const getSortIcon = (columnIndex) => {
    if (!sortableColumns.includes(columnIndex)) return null;

    if (sortConfig?.columnIndex === columnIndex) {
      return sortConfig.direction === 'asc' ? ' ▲' : ' ▼';
    }
    return ' ⇅';
  };

  const handleHeaderClick = (columnIndex) => {
    if (sortableColumns.includes(columnIndex) && onSort) {
      onSort(columnIndex);
    }
  };

  return (
    <thead>
        <tr>
            {
            columns.length > 0 &&
            columns.map((coluna, index) => (
                <th
                  key={index}
                  onClick={() => handleHeaderClick(index)}
                  className={sortableColumns.includes(index) ? 'sortable-header' : ''}
                  style={sortableColumns.includes(index) ? {cursor: 'pointer', userSelect: 'none'} : {}}
                >
                  {coluna}{getSortIcon(index)}
                </th>
            ))
            }
        </tr>
    </thead>
  )
}

export default TableHeader;